import api from './api';

// Interface base para Programa
export interface Programa {
  id: number;
  nome: string;
  mnemonico?: string;
  dataremocao?: string;
  idmongodb?: string;
  principal_id?: number;
}

// Interface para criação de Programa
export interface ProgramaCreate {
  nome: string;
  mnemonico?: string;
  principal_id?: number;
  idmongodb?: string;
}

// Interface para atualização de Programa
export interface ProgramaUpdate {
  nome?: string;
  mnemonico?: string;
  principal_id?: number;
  idmongodb?: string;
}

// Interface para filtros de busca
export interface ProgramaFilter {
  nome?: string;
  mnemonico?: string;
  principal_id?: number;
}

const ProgramasService = {
  // Obter lista de programas com filtragem e paginação
  getProgramas: async (filter: ProgramaFilter = {}, skip: number = 0, limit: number = 10): Promise<Programa[]> => {
    try {
      const response = await api.get('/programas/', {
        params: {
          ...filter,
          skip,
          limit
        }
      });
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar programas:', error);
      throw error;
    }
  },

  // Obter programa por ID
  getProgramaById: async (id: number): Promise<Programa> => {
    try {
      const response = await api.get(`/programas/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erro ao buscar programa ${id}:`, error);
      throw error;
    }
  },

  // Criar novo programa
  createPrograma: async (programa: ProgramaCreate): Promise<Programa> => {
    try {
      const response = await api.post('/programas/', programa);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar programa:', error);
      throw error;
    }
  },

  // Atualizar programa existente
  updatePrograma: async (id: number, programa: ProgramaUpdate): Promise<Programa> => {
    try {
      const response = await api.put(`/programas/${id}`, programa);
      return response.data;
    } catch (error) {
      console.error(`Erro ao atualizar programa ${id}:`, error);
      throw error;
    }
  },

  // Excluir programa
  deletePrograma: async (id: number): Promise<void> => {
    try {
      await api.delete(`/programas/${id}`);
    } catch (error) {
      console.error(`Erro ao excluir programa ${id}:`, error);
      throw error;
    }
  },

  // Obter contagem total
  getProgramasCount: async (filter: ProgramaFilter = {}): Promise<number> => {
    try {
      const response = await api.get('/programas/count', {
        params: filter
      });
      return response.data || 0;
    } catch (error) {
      console.error('Erro ao obter contagem de programas:', error);
      throw error;
    }
  },

  // Obter todos os programas (para dropdown/select)
  getAllProgramas: async (): Promise<Programa[]> => {
    try {
      const response = await api.get('/programas/all/list');
      return response.data || [];
    } catch (error) {
      console.error('Erro ao buscar lista de programas:', error);
      throw error;
    }
  }
};

export default ProgramasService;
